(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.dataset.sticky != 'true') return;
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky');
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
      const headerSearch = this.header.querySelector('.yrp-header-search');
      if (headerSearch) headerSearch.open = false;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    const headerMenus = Array.from(document.querySelectorAll('.yrp-header-links__item'));
    headerMenus.forEach((menu) => {
      menu.addEventListener('toggle', () => {
        if (menu.open) headerMenus.forEach((other) => { if (other !== menu) other.open = false; });
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
    });
    document.addEventListener('click', (event) => {
      headerMenus.forEach((menu) => { if (!menu.contains(event.target)) menu.open = false; });
    });
    const mediaQuery = window.matchMedia('(max-width: 989px)');
    const shopMenu = document.querySelector('#shopify-section-header .header__shop-menu');
    const trigger = shopMenu?.querySelector('.header__shop-all');

    if (!shopMenu || !trigger) return;

    const closeShopMenu = () => {
      shopMenu.classList.remove('is-mobile-open');
      shopMenu.classList.remove('is-open');
      shopMenu.removeAttribute('open');
      trigger.setAttribute('aria-expanded', 'false');
    };

    const openDesktopShopMenu = () => {
      if (mediaQuery.matches) return;
      shopMenu.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    };

    shopMenu.addEventListener('mouseenter', openDesktopShopMenu);
    shopMenu.addEventListener('mouseleave', () => {
      if (!mediaQuery.matches) closeShopMenu();
    });

    shopMenu.addEventListener('focusin', openDesktopShopMenu);
    shopMenu.addEventListener('focusout', (event) => {
      if (!mediaQuery.matches && !shopMenu.contains(event.relatedTarget)) closeShopMenu();
    });

    shopMenu.addEventListener('toggle', () => {
      trigger.setAttribute('aria-expanded', shopMenu.open ? 'true' : 'false');
    });

    trigger.addEventListener('click', (event) => {
      if (!mediaQuery.matches) return;

      event.preventDefault();
      const willOpen = !shopMenu.classList.contains('is-mobile-open');
      closeShopMenu();

      if (willOpen) {
        shopMenu.classList.add('is-mobile-open');
        trigger.setAttribute('aria-expanded', 'true');
      } else {
        trigger.blur();
      }
    });

    document.addEventListener('click', (event) => {
      if (!shopMenu.contains(event.target)) closeShopMenu();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeShopMenu();
    });

    mediaQuery.addEventListener('change', closeShopMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-bestsellers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const initialiseRows = () => {
      document.querySelectorAll('.yrp-bestsellers__mobile-rows').forEach((group) => {
        group.querySelectorAll('.yrp-bestsellers__mobile-row').forEach((row, index) => {
          if (row.dataset.yrpAutoScroll === 'true') return;
          row.dataset.yrpAutoScroll = 'true';
          const originals = Array.from(row.children);
          if (!originals.length) return;
          const copies = originals.map((card) => {
            const copy = card.cloneNode(true);
            copy.setAttribute('aria-hidden', 'true');
            copy.querySelectorAll('a, button, input').forEach((link) => link.setAttribute('tabindex', '-1'));
            row.appendChild(copy);
            return copy;
          });
          let position = 0;
          let cycle = 0;
          let previousTime = performance.now();
          let resumeAt = 0;
          let hovered = false;
          let focused = false;
          let visible = false;
          const direction = index === 0 ? -1 : 1;
          const measure = () => {
            cycle = copies[0].offsetLeft - originals[0].offsetLeft;
            position = direction < 0 ? cycle : 0;
            row.scrollLeft = motion.matches ? 0 : position;
            copies.forEach((copy) => { copy.hidden = motion.matches; });
          };
          const pause = () => { resumeAt = performance.now() + 2400; };
          row.addEventListener('pointerdown', pause, { passive: true });
          row.addEventListener('touchstart', pause, { passive: true });
          row.addEventListener('wheel', pause, { passive: true });
          row.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') hovered = true; });
          row.addEventListener('pointerleave', () => { hovered = false; pause(); });
          row.addEventListener('focusin', () => { focused = true; });
          row.addEventListener('focusout', () => { focused = row.contains(document.activeElement); pause(); });
          const observer = new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; });
          observer.observe(row);
          const resize = new ResizeObserver(measure);
          resize.observe(row);
          motion.addEventListener('change', measure);
          measure();
          const move = (time) => {
            if (!row.isConnected) { observer.disconnect(); resize.disconnect(); motion.removeEventListener('change', measure); return; }
            const elapsed = Math.min((time - previousTime) / 1000, .05);
            previousTime = time;
            if (!motion.matches && visible && !document.hidden && !hovered && !focused && time >= resumeAt && cycle > row.clientWidth) {
              position += direction * 32 * elapsed;
              if (position < 0) position += cycle;
              if (position >= cycle) position -= cycle;
              row.scrollLeft = position;
            } else {
              position = row.scrollLeft;
            }
            window.requestAnimationFrame(move);
          };
          window.requestAnimationFrame(move);
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseRows, { once: true });
    else initialiseRows();
    document.addEventListener('shopify:section:load', initialiseRows);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const backLink = event.target.closest('[data-yrp-collection-back]');
    if (!backLink || !document.referrer || window.history.length < 2) return;
    event.preventDefault();
    window.history.back();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  if (!customElements.get('yrp-product-recommendations')) {
    customElements.define('yrp-product-recommendations', class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        this.animationFrame = null;
        this.resumeTimer = null;
        this.lastFrameTime = null;
        this.loopPoint = 0;
        this.autoPosition = 0;

        this.addEventListener('pointerdown', () => this.pauseAutoplay());
        this.addEventListener('wheel', () => this.pauseAutoplay(), { passive: true });
        this.addEventListener('focusin', () => this.pauseAutoplay());

        const observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('yrp-product-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
                this.prepareContinuousLoop();
                this.startAutoplay();
              }
            })
            .catch(() => {});
        }, { rootMargin: '0px 0px 200px 0px' });
        observer.observe(this);
        this.prepareContinuousLoop();
        this.startAutoplay();
      }

      prepareContinuousLoop() {
        const slider = this.querySelector('.product-recommendations__slider');
        if (!slider || slider.dataset.loopReady === 'true') return;

        const originalCards = Array.from(slider.children);
        if (originalCards.length < 2) return;

        const clones = originalCards.map((card) => {
          const clone = card.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
            element.setAttribute('tabindex', '-1');
          });
          slider.appendChild(clone);
          return clone;
        });

        this.loopPoint = clones[0].offsetLeft - originalCards[0].offsetLeft;
        slider.dataset.loopReady = 'true';
      }

      startAutoplay() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        window.cancelAnimationFrame(this.animationFrame);
        this.lastFrameTime = null;
        const slider = this.querySelector('.product-recommendations__slider');
        this.autoPosition = slider ? slider.scrollLeft : 0;
        this.animationFrame = window.requestAnimationFrame((time) => this.advanceSlider(time));
      }

      pauseAutoplay() {
        window.cancelAnimationFrame(this.animationFrame);
        window.clearTimeout(this.resumeTimer);
        this.resumeTimer = window.setTimeout(() => this.startAutoplay(), 9000);
      }

      advanceSlider(time) {
        const slider = this.querySelector('.product-recommendations__slider');
        if (!slider || !this.loopPoint) return;

        if (this.lastFrameTime !== null) {
          const elapsed = Math.min(time - this.lastFrameTime, 50);
          this.autoPosition += elapsed * 0.018;
          if (this.autoPosition >= this.loopPoint) this.autoPosition -= this.loopPoint;
          slider.scrollLeft = this.autoPosition;
        }

        this.lastFrameTime = time;
        this.animationFrame = window.requestAnimationFrame((nextTime) => this.advanceSlider(nextTime));
      }

      disconnectedCallback() {
        window.cancelAnimationFrame(this.animationFrame);
        window.clearTimeout(this.resumeTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
